import { Component, Input, OnInit } from '@angular/core';
import { Dictionary } from '../../models/IDictionary';

const success = 'success';
const info = 'info';
const warning = 'warning';
const danger = 'danger';

@Component({
  selector: 'ff-peer',
  templateUrl: './peer.component.html',
  styleUrls: ['./peer.component.scss']
})
export class PeerComponent implements OnInit {

  /**
   * Text to display in the peer
   * @internal
   */
  @Input() text: string = '';

  /**
   * Peer type
   * Options: success, info, warning, danger;
   * Default value: success
   * @internal
   */
  @Input() peerType: string = 'success';

  styleDictionary: Dictionary<any> = {};

  constructor() { }

  ngOnInit(): void {
    !this.validateType(this.peerType)
    ? this.peerType = success
    : '';
    this.createDictionary();
  }

  private createDictionary() {
    this.styleDictionary['success'] = 'success-peer';
    this.styleDictionary['info'] = 'info-peer';
    this.styleDictionary['warning'] = 'warning-peer';
    this.styleDictionary['danger'] = 'danger-peer';
  }

  private validateType = (type: string): boolean => {
    if(type !== success &&
      type !== info &&
      type !== warning &&
      type !== danger) {
        return false;
      }
    return true;
  }

}
